import { useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";

//routes
import { getLoginPageUrl } from "../routingConstants/AppUrls";

//constants
import { isAuthenticated } from "../../constants/Helpers";

import { LocaleContext } from "../LangRouter";
//contexts

const PrivateRouteGuard = ({ children }) => {
    const location = useLocation(),
        { locale } = useContext(LocaleContext);

    if (isAuthenticated()) {
        return <>{children}</>;
    }

    return <Navigate replace to={getLoginPageUrl(locale)} state={{ from: location }} />;
};

export default PrivateRouteGuard;
